<template lang="html">
  <header>
    <div class="container">
      <div class="row">
        <div class="col-md-4 text-left logo">
          Money Management Application
        </div>
        <!-- <div class="col-md-3 search">
          <input type="text" class="form-control" placeholder="Start typing to search..">
        </div> -->
        <div class="col-md-8 account text-right">
          <span>test@test.com</span>
          <img src="../assets/img/ava.png" alt="" class="avatar">
          <a href="#" @click="logout()">Log out</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import auth from '../auth'

export default {
  name: 'headline',
  methods: {
    logout () {
      auth.logout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Headline.vue?92037c04